import {
  Chip,
  ChipItemValueItem,
  ChipItemValuesList,
  ChipSeparator,
  ChipItemFacet,
  ChipItemClose,
  ChipItem,
} from '@src/design-system/chip';
import { SelectedItems } from '@src/features/tasks/pages/create/selected-items';
import memberApi from '@src/shared/services/member-api';

import { useSearchParams } from 'react-router-dom';

export default function ReminderCreatedByChip() {
  const [sp, setSp] = useSearchParams();
  const createdByParam = sp.get('created_by');

  const { data: membersData } = memberApi.useFetch(
    {
      user: createdByParam || undefined,
    },
    { enabled: !!createdByParam }
  );

  const member = membersData?.results?.[0];

  if (!createdByParam) return null;

  return (
    <Chip>
      <ChipItem className='h-[40px]'>
        <ChipItemClose
          onClick={() => {
            setSp((prev) => {
              prev.delete('created_by');
              return prev;
            });
          }}
        />
        <ChipItemFacet>Created By</ChipItemFacet>
        <ChipSeparator />
        <ChipItemValuesList>
          <ChipItemValueItem>
            {member && (
              <SelectedItems
                className='p-0 border-0 hover:border-0'
                items={[
                  {
                    avatar: member.user.avatar,
                    id: member.user.id,
                    name: member.user.first_name,
                  },
                ]}
              />
            )}
          </ChipItemValueItem>
        </ChipItemValuesList>
      </ChipItem>
    </Chip>
  );
}
